import { HttpClient } from '@angular/common/http';
import {
    Injectable
} from '@angular/core';
import {
    catchError,
    map,
    Observable,
    of
} from 'rxjs';
import {
    Result,
    ResultResponse
} from 'src/app/models/survey/result';
import {
    Survey
} from 'src/app/models/survey/survey';

@Injectable({
    providedIn: 'root'
})
export class SurveyV2Service {
    apiUrl = "https://data2.ifa.com/api/v2/survey/"
    constructor(private http: HttpClient) {}

    advisors_dropdown$(surveyId: number): Observable < Survey[] > {
        return this.http.get < Survey[] > (`${this.apiUrl}${surveyId}/advisors`).pipe(
            catchError(err => {
                return of("error loading advisors dropdown. try again later...", err)
            })
        );
    }

    survey_new$(surveyId: number): Observable < Survey > {
        return this.http.get < Survey[] > (`${this.apiUrl}${surveyId}`).pipe(
            catchError(err => {
                return of("error loading survey. try again later...", err)
            })
        );
    }

    // survey answer question
    survey_question_answered$(data: any) {
        return this.http.put(`${this.apiUrl}update-response/`, data).pipe(
          catchError(err => {
              return of("error submitting answer to server. try again later...", err)
          })
        );        
    }

    //survey finish
    survey_finish$(guidSurveyResultID: string) {
        return this.http.put(`${this.apiUrl}finish/`, {GuidSurveyResultID:guidSurveyResultID}).pipe(
            catchError(err => {
                return of("error finalizing survey with the server. try again later...", err)
            })
        );        
    }

    // survey_profile_submit
    survey_profile_submit$(formData: any) {
        return this.http.post(`${this.apiUrl}user/`, formData).pipe(
            catchError(err => {
                return of("error submitting profile form to the server. try again later...", err)
            })
        );        
    }

    //survey result
    survey_result$(guidSurveyResultID: string) {
        return this.http.post(`${this.apiUrl}result/`,{GuidSurveyResultID:guidSurveyResultID}).pipe(
            catchError(err => {
                return of("error getting survey results from the server. try again later...", err)
            })
        );        
    }

    
}